import Vue from 'vue';
import VueResource from 'vue-resource';

import router from '@/common/utils/router';
import App from '@/App';

// vuex
import store from '@/common/store';

// 通用组件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 全局注册（共用方法、常量值、颜色值 etc）
import GlobalConfig from '@/common/utils/global-config';

// 阿里巴巴字体图标库
import '../public/iconfont/iconfont.css';

import 'animate.css';

import OrdinaryMixin from '@/common/mixin/ordinary-mixin';

Vue.use(VueResource);

Vue.use(ElementUI);

Vue.prototype.$store = store;

Vue.use({
  install(Vue) {
    Vue.prototype.$sn = GlobalConfig.$sn;
  }
});

const sn = require('@/common/store/$sn.mixin');
Vue.mixin(sn);

Vue.mixin(OrdinaryMixin);

/*
* 批量注册全局共用组件
* 1）仅在此处注册以“sn-”开头，以“.vue”结尾的组件
* 2）要在组件内使用 name 属性命名
* */
const assembly = require.context('@/components/common', true, /sn-.+\.vue$/);
assembly.keys().forEach(el => {
  const single = assembly(el).default;
  Vue.component(single.name, single);
});

window.eventBus = new Vue();

Vue.config.productionTip = false;

const vue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});

export default vue;
